export default __webpack_public_path__ + "media/images/81-e882b92605410b3b5a65367a93f0ad1b.jpg";